/**
 * Extensões que são apenas apelidos de um formato já suportado pelo WhatsApp.
 *
 * O backend preserva o nome original ao subir para o S3 (`sanitizeFilename`), e o
 * provedor (Z-API/Meta) decide o tipo do anexo pela extensão da URL. Um `.jfif`,
 * apesar de ser um JPEG comum, não é reconhecido e o envio é recusado — renomear
 * antes do upload resolve sem reencodar o arquivo.
 */
const EXTENSION_ALIASES: Record<string, { extension: string; mimeType: string }> = {
  jfif:  { extension: 'jpg', mimeType: 'image/jpeg' },
  jpe:   { extension: 'jpg', mimeType: 'image/jpeg' },
  jif:   { extension: 'jpg', mimeType: 'image/jpeg' },
  pjp:   { extension: 'jpg', mimeType: 'image/jpeg' },
  pjpeg: { extension: 'jpg', mimeType: 'image/jpeg' },
};

/**
 * Devolve o mesmo `File` quando não há nada a normalizar; caso contrário, uma cópia
 * com extensão e content-type canônicos (o conteúdo binário não é alterado).
 */
export function normalizeUploadFile(file: File): File {
  const dotIndex = file.name.lastIndexOf('.');
  if (dotIndex <= 0) return file;

  const alias = EXTENSION_ALIASES[file.name.slice(dotIndex + 1).toLowerCase()];
  if (!alias) return file;

  const name = `${file.name.slice(0, dotIndex)}.${alias.extension}`;
  return new File([file], name, { type: alias.mimeType, lastModified: file.lastModified });
}
 